import http from '@/libs/AxiosPlugin'

const order = {
  list () {
    return http.get('/orderProduct/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, orderNo: 'o-001', productNo: 'xt-001', number: 30, unit: '米', attritionRate: 0.1, ordersTime: '2017-09-01', deliveryTime: '2017-10-01', customer: '心恬', salesman: 'xxx', valid: 1},
    //     {id: 2, orderNo: 'o-001', productNo: 'xt-002', number: 30, unit: '米', attritionRate: 0.1, ordersTime: '2017-09-01', deliveryTime: '2017-10-01', customer: '心恬', salesman: 'xxx', valid: 1}
    //   ]
    //   resolve(data)
    // })
  },

  get (id) {
    return http.post('/orderProduct/get', {id})
  },

  save (order) {
    return http.post('/orderProduct/save', order)
  },

  delete (id) {
    return http.post('/order/delete', {id})
  },

  change (id) {
    return http.post('/orderProduct/change', {id})
  }
}

export default order



// WEBPACK FOOTER //
// ./src/api/order.js